export default {"src":"/_next/static/media/lightningCloud_64.c8f0a6fd.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};